import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Navbar from './NavbarNew';
import Sidebar from './SidebarNew';
import AiChatPanel from '../common/AiChatPanel';
import { MainLayoutSkeleton } from '../common/Skeleton';
import { useTranslation } from 'react-i18next';


const MainLayout = () => {
  const { isAuthenticated, loading, hasSeenOnboarding } = useAuth();
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  if (loading) {
    return <MainLayoutSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // First-ever login → redirect to onboarding tutorial
  if (!hasSeenOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar
        onMenuClick={() => {
          if (window.innerWidth >= 1024) {
            setSidebarCollapsed(prev => !prev);
          } else {
            setSidebarOpen(true);
          }
        }}
        sidebarCollapsed={sidebarCollapsed}
      />
      
      <div className="flex">
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)}
          collapsed={sidebarCollapsed}
        />
        
        <main className="flex-1 p-3 sm:p-6 lg:p-8 min-h-[calc(100vh-4rem)] overflow-x-hidden">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* AI Chat Floating Panel */}
      <AiChatPanel />

      {/* Footer */}
      <footer className="border-t border-gray-200 dark:border-gray-700/60 py-5">
        <div className="mx-auto max-w-7xl px-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-400 dark:text-white/40">
          <span>
            &copy; {new Date().getFullYear()} {t('layout.footer.copyrightPrefix')} · {t('layout.footer.tagline')}
          </span>
          <span className="hidden sm:inline text-gray-300 dark:text-white/20" aria-hidden>
            |
          </span>
          <a
            href="http://cms.trilogy.fanselector.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-md px-2 py-1 text-gray-500 hover:text-gray-700 dark:text-white/35 dark:hover:text-white/55 transition-colors"
          >
            <img
              src="/gblogo.png"
              alt="Greybeard"
              className="h-5 sm:h-6 w-auto opacity-95 hover:opacity-100 transition-opacity"
            />
            <span>
              <span className="text-gray-400 dark:text-white/30">{t('layout.footer.technologyPartner')} · </span>
              Greybeard
            </span>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;
